import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { usePlatformAuth } from "@/contexts/PlatformAuthContext";

// Shown app-wide to a subscriber whose renewal payment failed (subscription_state
// === "past_due"). Access is on hold until a payment succeeds; Stripe keeps
// retrying for 7 days. Mirrors the payment-failed email copy. Dash-free strings.
export const PastDueBanner = () => {
  const { subscriptionState } = usePlatformAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (subscriptionState !== "past_due") return null;

  return (
    <div
      data-testid="past-due-banner"
      className="w-full px-6 py-3 flex flex-col sm:flex-row items-center justify-center gap-3 text-center"
      style={{ background: "#7f1d1d", color: "#fff" }}
    >
      <AlertTriangle size={18} className="shrink-0" />
      <span className="text-sm font-medium" data-testid="past-due-message">
        {t("billing.pastDueBanner")}
      </span>
      <button
        onClick={() => navigate("/account/billing")}
        data-testid="past-due-update-card"
        className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-semibold whitespace-nowrap"
        style={{ background: "#fff", color: "#7f1d1d" }}
      >
        {t("billing.pastDueCta")}
      </button>
    </div>
  );
};

export default PastDueBanner;
